import React from 'react';

export type FilmaizeTextType = 'text' | 'number' | 'email' | 'password' | 'tel' | 'url';

interface FilmaizeTextProps {
  label?: string;
  value: string | number | null | undefined;
  onChange: (value: any) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  readOnly?: boolean;
  required?: boolean;
  infoText?: string;
  placeholder?: string;
  type?: FilmaizeTextType;
  step?: string | number;
  min?: string | number;
  max?: string | number;
  icon?: boolean;
  inputStyle?: React.CSSProperties;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  [key: string]: any; // Allow additional HTML input attributes
}

const FilmaizeText: React.FC<FilmaizeTextProps> = (props) => {
  const { className, readOnly, label, required, infoText, value, onChange, placeholder, type = "text", step, min, icon, inputStyle, ...rest } = props;

  const handleOnChange = (e) => {
    onChange(e.target.value);
  }

  const handleKeyDown = (e) => {
    if (type === "number" && (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-')) {
      e.preventDefault();
    }
    if (rest.onKeyDown) {
      rest.onKeyDown(e);
    }
  };

  // Apply defaults for number inputs
  const numberProps = type === "number" ? {
    step: step !== undefined ? step : "0.1",
    min: min !== undefined ? min : "0"
  } : {};

  return (
    <div className={`field ${className}`}>
      {label && <label className={"label " + (readOnly ? "is-disabled" : "")}>
        {label}
        {required ? <span className="required">&nbsp;*</span> : null}
        {infoText && (
          <span className="ml-1 material-icons" data-tool-tip={infoText}>
            info
          </span>
        )}
      </label>}
      <div className={`control ${icon ? "has-icons-right" : ""}`}>
        <input
          className="input"
          type={type}
          placeholder={placeholder ?? label}
          value={value ?? ''}
          onChange={handleOnChange}
          onKeyDown={handleKeyDown}
          disabled={readOnly}
          style={inputStyle}
          {...numberProps}
          {...rest}
        />
        {icon &&
          <span className="icon is-small is-right">
            <i className="material-icons">eye</i>
          </span>
        }
      </div>
    </div>
  );
};

export default FilmaizeText;
